import React, { useEffect, useState } from "react";
import PortalSweb from "cldffecop-web-portal";

export const Modal = ({ children }) => {
  const [height, setHeight] = useState();
  const [loading, setLoading] = useState(true);
  const sourceBody = document.getElementsByTagName("body")[0];

  const calculateHeight = (body) =>
    Math.max(body.scrollHeight, body.clientHeight);

  useEffect(() => {
    setLoading(false);
  }, []);

  useEffect(() => {
    setTimeout(() => {
      setHeight(calculateHeight(sourceBody));
    }, 10);
  }, [!loading]);

  return (
    <PortalSweb visible={true}>
      {children}
      <div
        style={{
          position: "fixed",
          width: "100%",
          height: `${height + 1000}px`,
          top: 0,
          background: "#000",
          opacity: 0.3,
          zIndex: 90,
        }}
      >
        {""}
      </div>
    </PortalSweb>
  );
};
